/**
 * Conversational voice mode tuning constants. Measured/sensible defaults —
 * exposed here (not buried in ChatInput.tsx) specifically so they're easy
 * to retune without hunting through the component.
 */

export const SILENCE_END_MS = 1200; // end of turn after speech
export const MIN_SPEECH_MS = 400; // below this, discard the turn
export const MAX_UTTERANCE_MS = 30000; // hard cap, force end
export const RECORDER_RESET_MS = 10000; // restart recorder if no speech yet
export const SESSION_IDLE_MS = 60000; // auto-stop conversation, return to IDLE
export const AUDIO_BITRATE_BPS = 24000;

export const FIRST_CHUNK_MAX_CHARS = 30;
export const CHUNK_MIN_CHARS = 60;
export const CHUNK_HARD_MAX_CHARS = 2500;

export const LANG_CONFIDENCE_MIN = 0.8;

export const SENTENCE_BOUNDARY = /[.!?।॥]+[\s]*/;

// Barge-in (Segment V1.3). BARGE_IN_ENABLED is the switch: false restores
// byte-identical pre-V1.3 behaviour (nothing dispatches BARGE_IN_DETECTED,
// no BargeInDetector is ever constructed).
export const BARGE_IN_ENABLED = true;
export const ECHO_CALIBRATION_MS = 600; // measure echo floor at playback start
export const BARGE_IN_MARGIN = 2.5; // threshold = echoFloor * margin
export const BARGE_IN_CONFIRM_MS = 300; // longer than LISTENING's 150ms
export const BARGE_IN_MIN_PLAYBACK_MS = 500; // no barge-in before this into a chunk
export const BARGE_IN_MAX_PER_MIN = 6; // circuit breaker
